import { SubscriberProductResponseDto } from '@subflow/api-client';
import { Dayjs } from 'dayjs';
import { Dispatch, SetStateAction, createContext, useState } from 'react';

const initialState = {
  ageRestrictionConfirmed: false,
  product: null,
  ageRestrictionValue: null,
  ageRestrictionActive: false,
  birthDate: null,
  setBirthDate: () => null,
  setAgeRestrictionConfirmed: () => null,
};

interface AgeGateContextType {
  product: SubscriberProductResponseDto;
  // handleSubmit: FormEventHandler;
  ageRestrictionValue: number;
  ageRestrictionActive: boolean;
  ageRestrictionConfirmed: boolean;
  birthDate: Dayjs | null;
  setBirthDate: (date: Dayjs | null) => void;
  setAgeRestrictionConfirmed: Dispatch<SetStateAction<boolean>>;
}

export const AgeGateContext = createContext<AgeGateContextType>(initialState);

export const AgeGateProvider = ({ children, product }) => {
  const [ageRestrictionConfirmed, setAgeRestrictionConfirmed] = useState(
    initialState.ageRestrictionConfirmed
  );
  const [birthDate, setBirthDate] = useState<Dayjs | null>(null);
  const { ageRestrictionActive, ageRestrictionValue } = product;

  const value = {
    product,
    birthDate,
    setBirthDate,
    setAgeRestrictionConfirmed,
    ageRestrictionActive,
    ageRestrictionValue,
    ageRestrictionConfirmed,
  };

  return (
    <AgeGateContext.Provider value={value}>{children}</AgeGateContext.Provider>
  );
};
